var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search-Content",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Loop",
    stroke: "#9DA2A6",
    strokeWidth: 2,
    transform: "translate(24 24)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6,
    cy: 6,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    strokeLinecap: "round",
    d: "M10.5,10.5 L15.5,15.5"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Spacer-square",
    width: 64,
    height: 64
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGrey);
export default __webpack_public_path__ + "static/media/SearchGrey.1e74fdb8fc9651167147c7ff86b527e1.svg";
export { ForwardRef as ReactComponent };